import { AutoMap } from "@automapper/classes";

export class GenerateurEntity {

    Id?: number;
    @AutoMap()
    TaskStatus!: number
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingDate!: string;
    @AutoMap()
    ZoneSalle!: string;
    @AutoMap()
    Marque!: string;
    @AutoMap()
    Modele!: string;
    @AutoMap()
    NumSerie!: string;
    @AutoMap()
    NumAppareil!: string;

    PrelevementGenerateurDialyseIds!: number[];
}